'use strict';
import Auth from "./Auth";

class Agreements {
  static getLastAgreement(filters = null) {
    return fetch(
      `${BASE_URL}api/agreements/last?${new URLSearchParams(filters).toString()}`,
      {
        method: 'GET',
        headers: {
          'Cache-Control': 'no-cache'
        }
      }
    )
      .then(response => {
        return response.json();
      })
      .then(response => {
        return new Promise(function(resolve, reject) {
          if (response.error) {
            reject(Error('Error'));
          } else {
            resolve(response.data);
          }
        });
      });
  }

  static _getLastTermOfService(scope = 'company') {
    return this.getLastAgreement({
      type: 'terms_of_service',
      scope: scope
    });
  }

  static _getLastPrepaidAgreement() {
    return this.getLastAgreement({
      type: 'prepaid_agreement'
    });
  }

  static agreementPDF(params, isHtml = false){
    return Auth.makePrivatePost(`${BASE_URL}agreement-pdf${isHtml?'?html=true':''}`, params);
  }

  static _agreementDownloadExternalSeller(params){
    var queryString = Object.keys(params)
            .map(k => encodeURIComponent(k) + '=' + encodeURIComponent(params[k]))
            .join('&');
    return Auth.makePrivateBlobGet(`${BASE_URL}api/agreements/download/external-seller?${queryString}`);
  }

  static _getLastUserGuide(scope) {
    return this.getLastAgreement({
      type: 'user_guidelines',
      scope: scope
    });
  }
}

export default Agreements;
